<template>
  <div class="m-mine">
    <div class="navbar"><h1>我的</h1></div>

    <div class="scroll mn-scroll">
      <div class="mine-hd">
        <div class="mn-user">
          <div class="mn-av">{{ userInfo.avatar }}</div>
          <div>
            <div class="nm">{{ userInfo.name }}</div>
            <div class="sub" v-if="userInfo.phone">{{ userInfo.phone }}</div>
          </div>
        </div>
      </div>
      <div class="mn-body">
        <div class="cell" @click="goToPwd">
          <span class="ic" style="background:var(--primary-l);color:var(--primary-d)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect
              x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
          </span>
          <span class="tx">修改密码</span>
          <svg class="ar" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 5l7 7-7 7"/>
          </svg>
        </div>
        <div class="cell">
          <span class="ic" style="background:var(--purple-l);color:var(--purple)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle
              cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/></svg>
          </span>
          <span class="tx">关于我们</span>
          <span class="vl">v2.8.2</span>
        </div>
      </div>
      <div class="logout">
        <button class="btn" @click="handleLogout">退出登录</button>
      </div>
    </div>
    <m-tab-bar/>

      <m-confirm
      :visible.sync="showLogout"
      title="退出登录"
      content="确认退出当前账号？"
      okText="退出"
      cancelText="取消"
      :ok-disabled="loggingOut"
      @ok="doLogout"
    />
  </div>
</template>

<script>
import MTabBar from './MTabBar.vue';
import MConfirm from './MConfirm.vue';
import mobileRem from '@/commonJs/mobileRem';
import ApiService from '@/service/ApiService';
import pub from '@/service/public';
import cookie from '@/service/cookie';

export default {
  name: 'MMine',
  components: {
    MTabBar,
    MConfirm
  },
  mixins: [mobileRem],
  data() {
    return {
      showLogout: false,
      loggingOut: false,
      userInfo: {
        name: '用户',
        avatar: '用',
        phone: ''
      }
    };
  },
  mounted() {
    this.loadUserInfo();
  },
  methods: {
    // 与 PC AppHeader.loadUserInfo 一致，读取本地存储的真实用户信息
    loadUserInfo() {
      const str = cookie.getCookie('28project_UsrInfo');
      if (str) {
        try {
          const info = JSON.parse(str);
          const name = info.strUsrRealName || '用户';
          this.userInfo = {
            name: name,
            avatar: name ? name.charAt(0) : '用',
            phone: this.$cookies.get('28project_username') || ''
          };
        } catch (e) {
          console.error('解析用户信息失败：', e);
        }
      }
    },
    goToPwd() {
      this.$router.push('/m/pwd');
    },
    handleLogout() {
      this.showLogout = true;
    },
    // 与 PC AppHeader.handleLogout 一致，仅 agent 改为 mobile；
    // 会发起退出请求，但无论请求成功还是失败都会清空登录信息并跳转
    doLogout() {
      if (this.loggingOut) return
      this.loggingOut = true
      const accountStr = cookie.getCookie('28project_UsrInfo');
      const accountInfo = accountStr ? JSON.parse(accountStr) : {};
      const params = {
        page: {number: 0, limit: 1},
        keyWord: [],
        parms: {
          strClientUuid: 'A0F9GQHU6YE3D5AG',
          strUsrUuid: accountInfo.strUsrUUID
        }
      };
      const clearAndRedirect = () => {
        cookie.removeCookie('28project_UsrInfo');
        pub.clearLoginState();
        // 保留用户名 cookie，便于下次自动填充
        this.$router.replace('/m/login');
      };
      ApiService.UsrLogout(params, 'mobile')
        .then(() => clearAndRedirect())
        .catch(error => {
          console.error('退出登录失败：', error);
          clearAndRedirect();
        })
        .finally(() => {
          this.loggingOut = false
        });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent
}

.m-mine {
  --primary: #12b3a8;
  --primary-d: #0d9b91;
  --primary-l: #e8f8f6;
  --danger: #f5544b;
  --purple: #8b5cf6;
  --purple-l: #f3edff;
  --t1: #14181f;
  --t2: #5b6472;
  --t3: #9aa4b2;
  --line: #eef0f4;
  --bg: #f4f6f8;
  --card: #fff;
  --grad: linear-gradient(135deg, #14bcb0, #0b8f89);
  font-size: 14px;
  line-height: normal;
  -webkit-text-size-adjust: 100%;
  min-height: 100vh;
  background: var(--bg);
  display: flex;
  flex-direction: column
}

.navbar {
  height: 46px;
  flex: none;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: .5px solid rgba(0, 0, 0, .05)
}

.navbar h1 {
  font-size: 17px;
  font-weight: 600;
  color: var(--t1)
}

.scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(56px + env(safe-area-inset-bottom))
}

.mn-scroll {
  padding: 0 0 20px
}

.mine-hd {
  flex: none;
  background: var(--grad);
  color: #fff;
  padding: 10px 18px 54px
}

.mn-user {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-top: 8px
}

.mn-av {
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background: rgba(255, 255, 255, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  font-weight: 600;
  flex: none
}

.mn-user .nm {
  font-size: 18px;
  font-weight: 600
}

.mn-user .sub {
  font-size: 12.5px;
  opacity: .85;
  margin-top: 5px
}

.mn-body {
  margin: -38px 12px 0
}

.cell {
  display: flex;
  align-items: center;
  gap: 11px;
  height: 54px;
  padding: 0 14px;
  background: #fff;
  border-bottom: 1px solid var(--line);
  font-size: 14.5px;
  color: var(--t1);
  cursor: pointer
}

.cell:first-child {
  border-radius: 14px 14px 0 0
}

.cell:last-child {
  border-bottom: none;
  border-radius: 0 0 14px 14px
}

.cell .ic {
  width: 26px;
  height: 26px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none
}

.cell .ic svg {
  width: 15px;
  height: 15px
}

.cell .tx {
  flex: 1
}

.cell .vl {
  color: var(--t3);
  font-size: 13px
}

.cell .ar {
  width: 15px;
  height: 15px;
  color: #cfd5de;
  flex: none
}

.logout {
  margin: 22px 12px calc(10px + 56px + env(safe-area-inset-bottom))
}

.logout .btn {
  width: 100%;
  height: 46px;
  border-radius: 23px;
  font-size: 15.5px;
  background: #fff;
  color: var(--danger);
  border: 1px solid #f8cdc9;
  font-weight: 600
}

.ver {
  text-align: center;
  font-size: 11.5px;
  color: var(--t3);
  padding-bottom: 14px
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MMine.vue